export const themes = ['default', 'primary', 'secondary'];
export const themesButton = ['default', 'primary', 'secondary', 'transparent', 'text'];

export type Theme = typeof themes[number];
export type ThemeButton = typeof themesButton[number];